import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { ComposedActions } from '../../helpers/actions';
import { jsonToCSS } from '../../helpers/styles';
import blackStrip from './background-images/black-back-strip.png';
import key from './background-images/key.png';
import knob from './background-images/knob.png';
import stripBackground from './background-images/side-strip.png';
import speakerImg from './background-images/speaker.png';
import LedSwitch from './LedSwitch';
import { colors, dimension } from './WindowConfig';

export interface ILeftAnalogStripProps {}

const TopKeyLabel = styled.div`
  width: 80%;
  height: 45px;
  background-image: url(${blackStrip});
  color: white;
  margin-left: 24%;
  padding: 10px;
  border-top-left-radius: 10px;
`;
const KeyLabelContainer = styled.div`
  display: flex;
  margin-left: 5px;
`;
const RightKeyLabel = styled.div`
  padding-top: 9px;
  color: white;
  background-image: url(${blackStrip});
  width: 100%;
  height: 45px;
`;

const LedContainer = styled.div`
  display: flex;
  padding: 0px 15px;
  margin: 10px 0px;
`;

const Knob = styled.img`
  width: 100px;
  margin-left: 20px;
  margin-top: 150px;
  margin-bottom: 150px;
`;

const Key = styled.img<any>`
  width: 70px;
  margin-left: 20px;
  transition: transform 1s ease-in;
  cursor: pointer;
  object-fit: contain;
  ${({ enabled }) => {
    if (enabled) {
      return `transform: rotate(90deg);`;
    }
  }}
`;

const Speaker = styled.img`
  width: 130px;
  margin-left: 10px;
  margin-top: 60px;
`;

const Container = styled.div`
  ${jsonToCSS(dimension.lowerMonitorLeftStrip)};
  background-image: url(${stripBackground});
`;

export default function LeftAnalogStrip(props: ILeftAnalogStripProps) {
  const lowerMonitorButtons = useSelector(
    (state: any) => state.executor.s80.lowerMonitorButtons
  );
  const safeState = lowerMonitorButtons['safe_key'];
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(
      ComposedActions.PressGeneralButtonSwitch.aCreator({
        id: 'safe_key',
        isActive: !safeState,
      })
    );
  };
  return (
    <Container>
      <LedContainer>
        <LedSwitch showLed id="GB_fire">
          FIRE
        </LedSwitch>
      </LedContainer>
      <LedContainer>
        <LedSwitch showLed id="GB_stdwn">
          STDWN
        </LedSwitch>
      </LedContainer>
      <LedContainer>
        <LedSwitch showLed id="GB_cutter">
          CUTTER
        </LedSwitch>
      </LedContainer>
      <LedContainer>
        <LedSwitch showLed id="GB_battle_short">
          BATTLE <br /> SHORT
        </LedSwitch>
      </LedContainer>
      <LedContainer>
        <LedSwitch showLed id="GB_buzzer_reset">
          BUZZER <br /> RESET
        </LedSwitch>
      </LedContainer>
      <LedContainer>
        <LedSwitch showLed id="GB_mute">
          MUTE
        </LedSwitch>
      </LedContainer>
      <Knob src={knob} />
      <TopKeyLabel>SAFE</TopKeyLabel>
      <KeyLabelContainer>
        <Key
          id="safe_key"
          enabled={safeState}
          onClick={handleClick}
          src={key}
        />
        <RightKeyLabel>ENABLE</RightKeyLabel>
      </KeyLabelContainer>
      <Speaker src={speakerImg} />
    </Container>
  );
}
